import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, ArrowRight } from "lucide-react";
import api from "../../lib/api";

const typeColor = {
  event: "bg-light-blue text-brand-blue",
  holiday: "bg-soft-orange text-[color:var(--text-primary)]",
  celebration: "bg-brand-yellow/40 text-[color:var(--text-primary)]",
  activity: "bg-light-green text-[#1d6b32]",
};

const fmt = (iso) => {
  try {
    const d = new Date(iso);
    return { day: d.getDate(), month: d.toLocaleString("en", { month: "short" }) };
  } catch { return { day: "?", month: "" }; }
};

const CalendarPreview = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/calendar", { params: { upcoming_only: true } })
      .then((r) => setItems(r.data.slice(0, 5)))
      .catch(() => {});
  }, []);

  return (
    <section id="calendar" className="py-16 sm:py-24 bg-white" data-testid="calendar-preview-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5">
          <span className="text-brand-blue font-heading font-bold tracking-wider uppercase text-xs">Academic calendar</span>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold mt-2 mb-4">Coming up at school</h2>
          <p className="text-[color:var(--text-secondary)] mb-6">
            Holidays, celebrations, parent–teacher meetings and learning days — everything you
            need to plan the term ahead.
          </p>
          <Link to="/calendar" className="btn-primary" data-testid="calendar-view-all">
            View full calendar <ArrowRight size={16} />
          </Link>
        </div>

        <div className="lg:col-span-7">
          {items.length === 0 ? (
            <div className="text-[color:var(--text-secondary)]">Upcoming events will appear here.</div>
          ) : (
            <ul className="space-y-4">
              {items.map((e, i) => {
                const d = fmt(e.date);
                return (
                  <li key={e.id} className="card-soft bg-cream p-5 flex items-center gap-5" data-testid={`calendar-item-${i}`}>
                    <div className="w-16 h-16 rounded-2xl bg-brand-blue text-white flex flex-col items-center justify-center flex-shrink-0">
                      <div className="text-xs uppercase tracking-wider opacity-85">{d.month}</div>
                      <div className="font-heading text-2xl font-bold leading-none">{d.day}</div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1 flex-wrap">
                        <h3 className="font-heading font-bold">{e.title}</h3>
                        <span className={`px-2 py-0.5 rounded-full text-[0.7rem] font-semibold capitalize ${typeColor[e.event_type] || typeColor.event}`}>
                          {e.event_type}
                        </span>
                      </div>
                      {e.description && (
                        <p className="text-sm text-[color:var(--text-secondary)]">{e.description}</p>
                      )}
                    </div>
                    <Calendar size={20} className="text-brand-blue hidden sm:block" />
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </section>
  );
};

export default CalendarPreview;
